import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { withStyles } from "@material-ui/core/styles";
import moment from 'moment';


const CustomToolbar = (p) => {
    const classes = p.classes;
    const dt_agendamento = moment(p.state.dataAgenda, "DD/MM/YYYY");
    const dt_atual = moment();
    const dt_start = moment().add(-4,'days');
    const showBtPdf = !(dt_agendamento.isBetween(dt_start, dt_atual));

    return (
        <React.Fragment>
            {p.state.itensTable.length > 0 && showBtPdf &&
                <Tooltip title={'PDF'}>
                    <IconButton className={classes.iconButton} onClick={p.actionImprimir}>
                        <PictureAsPdfIcon className={classes.deleteIcon} />
                    </IconButton>
                </Tooltip>
            }
        </React.Fragment>
    );

};

export default withStyles((theme)=>({
    iconButton: {
        '&:hover': {
            color: theme.palette.primary.main
        },
    }
}),{ name: 'CustomToolbar'},)(CustomToolbar);